/** Keep customer-specified room names; personalize only generic defaults. */
export function customerRoomName(name?:string,room?:string){
 const last=name?.trim().split(/\s+/).filter(Boolean).at(-1);
 if(room&&!/^(?:Your (?:Family )?Bunk Room|Bunk room(?: \d+)?|Room \d+)$/i.test(room))return room;
 const number=room?.match(/(\d+)$/)?.[1];
 return `${last?last+' ':''}Bunk Room${number&&number!=='1'?' '+number:''}`;
}
